module.exports = __webpack_public_path__ + "static/media/IMG_1048.15525654.png";